import { useState } from 'react';
import usePayoutStructures from '@/hooks/usePayoutStructures';
import DataTable from '@/common/tableData/DataTable';
import DebouncedInput from '@/components/DebounceInput';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { IoDuplicate } from 'react-icons/io5';

const PayoutStructureTable = ({
  onEditPayoutStructure,
  onDeletePayoutStructure,
  onDuplicatePayoutStructure,
}: {
  onEditPayoutStructure: (payoutStructureId: string) => void;
  onDeletePayoutStructure?: (payoutStructure: any) => void;
  onDuplicatePayoutStructure?: (payoutStructure: any) => void;
}) => {
  const [search, setSearch] = useState('');

  const { payoutStructures } = usePayoutStructures();

  if (!payoutStructures) {
    return null;
  }

  return (
    <div className="d-flex flex-column gap-3 py-2">
      <div className="w-100 d-flex justify-content-start align-items-center gap-2 py-2">
        <DebouncedInput
          className="form-control w-auto"
          placeholder="Search"
          isLoading={false}
          onChange={(val) => setSearch(val as string)}
          value={search}
        />
      </div>
      <DataTable
        data={payoutStructures}
        columnFilters={[
          {
            id: 'name',
            value: search,
          },
        ]}
        columns={[
          {
            header: 'Actions',
            size: 10,
            cell: ({ row }) => (
              <div className="d-flex justify-content-start w-full flex-row">
                <AiOutlineEdit
                  size={20}
                  className="cursor-pointer"
                  onClick={() => onEditPayoutStructure(row.original.id)}
                />
              </div>
            ),
          },
          {
            header: 'Name',
            accessorKey: 'name',
            size: 600,
            filterFn: 'includesString',
          },
          {
            id: 'duplicate',
            header: () => <div className="d-flex justify-content-center w-full flex-row">Duplicate</div>,
            size: 10,
            cell: ({ row }) => (
              <div className="d-flex justify-content-center w-full flex-row">
                <IoDuplicate
                  size={20}
                  className="cursor-pointer"
                  onClick={() => onDuplicatePayoutStructure?.(row.original)}
                />
              </div>
            ),
          },
          {
            id: 'delete',
            header: () => <div className="d-flex justify-content-center w-full flex-row">Delete</div>,
            size: 10,
            cell: ({ row }) => (
              <div className="d-flex justify-content-center w-full flex-row">
                <AiOutlineDelete
                  size={20}
                  className="cursor-pointer"
                  onClick={() => onDeletePayoutStructure?.(row.original)}
                />
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};

export default PayoutStructureTable;
